// extracted by mini-css-extract-plugin
module.exports =  {"mark":"mark--MVIw6","selected":"selected--Yxfzh","highlighted":"highlighted--CgfLC","relation":"relation--yObzj","delete":"delete--vAUFD","row":"row--QlOlO"};